export default __webpack_public_path__ + "static/media/company.3d013636.svg";